import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { getDocument } from '../pnp-settings-compliance-report.actions';
import { IDS } from '../pnp-settings-compliance-report.constants';
import { getDocumentCategories } from '../../../pnp-docs/pnp-docs.actions';
import watch from 'redux-watch';

class pnpSettingsComplianceReportGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpComplianceReportGrid;
        this.filterTemplate = './pnp-settings-compliance-report-grid-filter.html';

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Document Number', mapper: 'docNum' },
            { title: 'Version', mapper: 'version' },
            { title: 'Title', mapper: 'title' },
            { title: 'Document Application Type', mapper: 'documentApplicationType' },
            { title: 'Location', mapper: 'location' },
            { title: 'Document Category', mapper: 'documentCategory' },
            { title: 'Document Type', mapper: 'documentType' },
            { title: 'Author', mapper: 'author' },
            { title: 'Created Date', mapper: 'created_date' },
            { title: 'Approval Due Date', mapper: 'approvalDueDate' },
            { title: 'Document Due Date', mapper: 'documentDueDate' },
            { title: 'Status', mapper: 'docStatus' },
            { title: 'LinkedToAccreditation', mapper: 'linkWithAccreditation'}
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocument, getDocumentCategories }
        )(this);
        this.filter.identifier = this.identifier;
        this.dataAction = this.getDocument;
        this.exportService = this.getDocument;

        this.buttons = [{
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event)
            },
            filter: item => {
                return item.downloadAllowed ? item.path : null;
            }
        }];

        const watchLocation = watch(this.$ngRedux.getState, 'policies.pnpComplianceReportGrid.filter.location');
        this.unsubscribeLocation = this.$ngRedux.subscribe(watchLocation((location) => {
            this.getDocumentCategories(location);
        }));

        this.init();
        this.buttonsDefault = this.buttons.concat();
    }


    $onDestroy() {
        this.destroy();
    }
}


pnpSettingsComplianceReportGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpSettingsComplianceReportGrid = {
    bindings: {
        title: '@',
        onDownload: '&',
        onReset: '&'
    },
    controller: pnpSettingsComplianceReportGridController,
    ...gridTpl
}
